module.exports = __webpack_public_path__ + "img/logo_phase03-768x424.61966445.png";